const AllQuestions = [


  {
    "id": "260121pyq1math1",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq1mathsol1.png"
  },
  {
    "id": "260121pyq1math2",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq1mathsol2.png"
  },
  {
    "id": "260121pyq1math3",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq1mathsol3.png"
  },
  {
    "id": "260121pyq1math4",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq1mathsol4.png"
  },
  {
    "id": "260121pyq1math5",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq1mathsol5.png"
  },

  {
    "id": "260121pyq1math6",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq1mathsol6.png"
  },
  {
    "id": "260121pyq1math7",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq1mathsol7.png"
  },
  {
    "id": "260121pyq1math8",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq1mathsol8.png"
  },
  {
    "id": "260121pyq1math9",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq1mathsol9.png"
  },
  {
    "id": "260121pyq1math10",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq1mathsol10.png"
  },
  {
    "id": "260121pyq1math11",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq1mathsol11.png"
  },
  {
    "id": "260121pyq1math12",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq1mathsol12.png"
  },
  {
    "id": "260121pyq1math13",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq1mathsol13.png"
  },
  {
    "id": "260121pyq1math14",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq1mathsol14.png"
  },
  {
    "id": "260121pyq1math15",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq1mathsol15.png"
  },
  {
    "id": "260121pyq1math16",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq1mathsol16.png"
  },
  {
    "id": "260121pyq1math17",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq1mathsol17.png"
  },
  {
    "id": "260121pyq1math18",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq1mathsol18.png"
  },
  {
    "id": "260121pyq1math19",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq1mathsol19.png"
  },
  {
    "id": "260121pyq1math20",
    "id_type": '260121pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq1mathques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq1mathsol20.png"
  },


  {
    "id": "260121pyq1phy1",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq1physol1.png"
  },
  {
    "id": "260121pyq1phy2",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq1physol2.png"
  },
  {
    "id": "260121pyq1phy3",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq1physol3.png"
  },
  {
    "id": "260121pyq1phy1",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq1physol1.png"
  },
  {
    "id": "260121pyq1phy5",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq1physol5.png"
  },

  {
    "id": "260121pyq1phy6",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq1physol6.png"
  },
  {
    "id": "260121pyq1phy7",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq1physol7.png"
  },
  {
    "id": "260121pyq1phy8",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq1physol8.png"
  },
  {
    "id": "260121pyq1phy9",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq1physol9.png"
  },
  {
    "id": "260121pyq1phy10",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq1physol10.png"
  },
  {
    "id": "260121pyq1phy11",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq1physol11.png"
  },
  {
    "id": "260121pyq1phy12",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq1physol12.png"
  },
  {
    "id": "260121pyq1phy13",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq1physol13.png"
  },
  {
    "id": "260121pyq1phy14",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq1physol14.png"
  },
  {
    "id": "260121pyq1phy15",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq1physol15.png"
  },
  {
    "id": "260121pyq1phy16",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq1physol16.png"
  },
  {
    "id": "260121pyq1phy17",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq1physol17.png"
  },
  {
    "id": "260121pyq1phy18",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq1physol18.png"
  },
  {
    "id": "260121pyq1phy19",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq1physol19.png"
  },
  {
    "id": "260121pyq1phy20",
    "id_type": '260121pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq1phyques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq1physol20.png"
  },

  {
    "id": "260121pyq1che1",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq1chesol1.png"
  },
  {
    "id": "260121pyq1che2",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq1chesol2.png"
  },
  {
    "id": "260121pyq1che3",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq1chesol3.png"
  },
  {
    "id": "260121pyq1che4",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq1chesol4.png"
  },
  {
    "id": "260121pyq1che5",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq1chesol5.png"
  },

  {
    "id": "260121pyq1che6",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq1chesol6.png"
  },
  {
    "id": "260121pyq1che1",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq1chesol1.png"
  },
  {
    "id": "260121pyq1che8",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq1chesol8.png"
  },
  {
    "id": "260121pyq1che9",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq1chesol9.png"
  },
  {
    "id": "260121pyq1che10",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq1chesol10.png"
  },
  {
    "id": "260121pyq1che11",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq1chesol11.png"
  },
  {
    "id": "260121pyq1che12",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq1chesol12.png"
  },
  {
    "id": "260121pyq1che13",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq1chesol13.png"
  },
  {
    "id": "260121pyq1che14",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq1chesol14.png"
  },
  {
    "id": "260121pyq1che15",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq1chesol15.png"
  },
  {
    "id": "260121pyq1che16",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq1chesol16.png"
  },
  {
    "id": "260121pyq1che17",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq1chesol17.png"
  },
  {
    "id": "260121pyq1che18",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq1chesol18.png"
  },
  {
    "id": "260121pyq1che19",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq1chesol19.png"
  },
  {
    "id": "260121pyq1che80",
    "id_type": '260121pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq1cheques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq1chesol20.png"
  },

  {
    "id": "260121pyq2math1",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq2mathsol1.png"
  },
  {
    "id": "260121pyq2math2",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq2mathsol2.png"
  },
  {
    "id": "260121pyq2math3",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq2mathsol3.png"
  },
  {
    "id": "260121pyq2math4",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq2mathsol4.png"
  },
  {
    "id": "260121pyq2math5",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq2mathsol5.png"
  },

  {
    "id": "260121pyq2math6",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq2mathsol6.png"
  },
  {
    "id": "260121pyq2math7",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq2mathsol7.png"
  },
  {
    "id": "260121pyq2math8",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq2mathsol8.png"
  },
  {
    "id": "260121pyq2math9",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq2mathsol9.png"
  },
  {
    "id": "260121pyq2math10",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq2mathsol10.png"
  },
  {
    "id": "260121pyq2math11",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq2mathsol11.png"
  },
  {
    "id": "260121pyq2math12",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq2mathsol12.png"
  },
  {
    "id": "260121pyq2math13",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq2mathsol13.png"
  },
  {
    "id": "260121pyq2math14",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq2mathsol14.png"
  },
  {
    "id": "260121pyq2math15",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq2mathsol15.png"
  },
  {
    "id": "260121pyq2math16",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq2mathsol16.png"
  },
  {
    "id": "260121pyq2math17",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq2mathsol17.png"
  },
  {
    "id": "260121pyq2math18",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq2mathsol18.png"
  },
  {
    "id": "260121pyq2math19",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq2mathsol19.png"
  },
  {
    "id": "260121pyq2math20",
    "id_type": '260121pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260121pyq2mathques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq2mathsol20.png"
  },


  {
    "id": "260121pyq2phy1",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq2physol1.png"
  },
  {
    "id": "260121pyq2phy2",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq2physol2.png"
  },
  {
    "id": "260121pyq2phy3",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq2physol3.png"
  },
  {
    "id": "260121pyq2phy1",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq2physol1.png"
  },
  {
    "id": "260121pyq2phy5",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq2physol5.png"
  },

  {
    "id": "260121pyq2phy6",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq2physol6.png"
  },
  {
    "id": "260121pyq2phy7",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq2physol7.png"
  },
  {
    "id": "260121pyq2phy8",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq2physol8.png"
  },
  {
    "id": "260121pyq2phy9",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq2physol9.png"
  },
  {
    "id": "260121pyq2phy10",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq2physol10.png"
  },
  {
    "id": "260121pyq2phy11",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq2physol11.png"
  },
  {
    "id": "260121pyq2phy12",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq2physol12.png"
  },
  {
    "id": "260121pyq2phy13",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq2physol13.png"
  },
  {
    "id": "260121pyq2phy14",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq2physol14.png"
  },
  {
    "id": "260121pyq2phy15",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq2physol15.png"
  },
  {
    "id": "260121pyq2phy16",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq2physol16.png"
  },
  {
    "id": "260121pyq2phy17",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq2physol17.png"
  },
  {
    "id": "260121pyq2phy18",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq2physol18.png"
  },
  {
    "id": "260121pyq2phy19",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq2physol19.png"
  },
  {
    "id": "260121pyq2phy20",
    "id_type": '260121pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260121pyq2phyques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq2physol20.png"
  },

  {
    "id": "260121pyq2che1",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq2chesol1.png"
  },
  {
    "id": "260121pyq2che2",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq2chesol2.png"
  },
  {
    "id": "260121pyq2che3",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq2chesol3.png"
  },
  {
    "id": "260121pyq2che4",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq2chesol4.png"
  },
  {
    "id": "260121pyq2che5",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq2chesol5.png"
  },

  {
    "id": "260121pyq2che6",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq2chesol6.png"
  },
  {
    "id": "260121pyq2che1",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq2chesol1.png"
  },
  {
    "id": "260121pyq2che8",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq2chesol8.png"
  },
  {
    "id": "260121pyq2che9",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq2chesol9.png"
  },
  {
    "id": "260121pyq2che10",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq2chesol10.png"
  },
  {
    "id": "260121pyq2che11",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq2chesol11.png"
  },
  {
    "id": "260121pyq2che12",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option4",
    "solution_img": "260121pyq2chesol12.png"
  },
  {
    "id": "260121pyq2che13",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq2chesol13.png"
  },
  {
    "id": "260121pyq2che14",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq2chesol14.png"
  },
  {
    "id": "260121pyq2che15",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq2chesol15.png"
  },
  {
    "id": "260121pyq2che16",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq2chesol16.png"
  },
  {
    "id": "260121pyq2che17",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq2chesol17.png"
  },
  {
    "id": "260121pyq2che18",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option3",
    "solution_img": "260121pyq2chesol18.png"
  },
  {
    "id": "260121pyq2che19",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option1",
    "solution_img": "260121pyq2chesol19.png"
  },
  {
    "id": "260121pyq2che80",
    "id_type": '260121pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260121pyq2cheques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option2",
    "solution_img": "260121pyq2chesol20.png"
  },


    {
    "id": "260122pyq1math1",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1mathsol1.png"
  },
  {
    "id": "260122pyq1math2",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1mathsol2.png"
  },
  {
    "id": "260122pyq1math3",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1mathsol3.png"
  },
  {
    "id": "260122pyq1math4",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1mathsol4.png"
  },
  {
    "id": "260122pyq1math5",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1mathsol5.png"
  },

  {
    "id": "260122pyq1math6",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1mathsol6.png"
  },
  {
    "id": "260122pyq1math7",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1mathsol7.png"
  },
  {
    "id": "260122pyq1math8",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1mathsol8.png"
  },
  {
    "id": "260122pyq1math9",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1mathsol9.png"
  },
  {
    "id": "260122pyq1math10",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1mathsol10.png"
  },
  {
    "id": "260122pyq1math11",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1mathsol11.png"
  },
  {
    "id": "260122pyq1math12",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1mathsol12.png"
  },
  {
    "id": "260122pyq1math13",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1mathsol13.png"
  },
  {
    "id": "260122pyq1math14",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1mathsol14.png"
  },
  {
    "id": "260122pyq1math15",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1mathsol15.png"
  },
  {
    "id": "260122pyq1math16",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1mathsol16.png"
  },
  {
    "id": "260122pyq1math17",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1mathsol17.png"
  },
  {
    "id": "260122pyq1math18",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1mathsol18.png"
  },
  {
    "id": "260122pyq1math19",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1mathsol19.png"
  },
  {
    "id": "260122pyq1math20",
    "id_type": '260122pyq1math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq1mathques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1mathsol20.png"
  },


  {
    "id": "260122pyq1phy1",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1physol1.png"
  },
  {
    "id": "260122pyq1phy2",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1physol2.png"
  },
  {
    "id": "260122pyq1phy3",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1physol3.png"
  },
  {
    "id": "260122pyq1phy1",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1physol1.png"
  },
  {
    "id": "260122pyq1phy5",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1physol5.png"
  },

  {
    "id": "260122pyq1phy6",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1physol6.png"
  },
  {
    "id": "260122pyq1phy7",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1physol7.png"
  },
  {
    "id": "260122pyq1phy8",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1physol8.png"
  },
  {
    "id": "260122pyq1phy9",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1physol9.png"
  },
  {
    "id": "260122pyq1phy10",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1physol10.png"
  },
  {
    "id": "260122pyq1phy11",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1physol11.png"
  },
  {
    "id": "260122pyq1phy12",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1physol12.png"
  },
  {
    "id": "260122pyq1phy13",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1physol13.png"
  },
  {
    "id": "260122pyq1phy14",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1physol14.png"
  },
  {
    "id": "260122pyq1phy15",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1physol15.png"
  },
  {
    "id": "260122pyq1phy16",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1physol16.png"
  },
  {
    "id": "260122pyq1phy17",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1physol17.png"
  },
  {
    "id": "260122pyq1phy18",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1physol18.png"
  },
  {
    "id": "260122pyq1phy19",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1physol19.png"
  },
  {
    "id": "260122pyq1phy20",
    "id_type": '260122pyq1phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq1phyques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1physol20.png"
  },

  {
    "id": "260122pyq1che1",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1chesol1.png"
  },
  {
    "id": "260122pyq1che2",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1chesol2.png"
  },
  {
    "id": "260122pyq1che3",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1chesol3.png"
  },
  {
    "id": "260122pyq1che4",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1chesol4.png"
  },
  {
    "id": "260122pyq1che5",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1chesol5.png"
  },

  {
    "id": "260122pyq1che6",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1chesol6.png"
  },
  {
    "id": "260122pyq1che1",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1chesol1.png"
  },
  {
    "id": "260122pyq1che8",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1chesol8.png"
  },
  {
    "id": "260122pyq1che9",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1chesol9.png"
  },
  {
    "id": "260122pyq1che10",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1chesol10.png"
  },
  {
    "id": "260122pyq1che11",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1chesol11.png"
  },
  {
    "id": "260122pyq1che12",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1chesol12.png"
  },
  {
    "id": "260122pyq1che13",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1chesol13.png"
  },
  {
    "id": "260122pyq1che14",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1chesol14.png"
  },
  {
    "id": "260122pyq1che15",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1chesol15.png"
  },
  {
    "id": "260122pyq1che16",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1chesol16.png"
  },
  {
    "id": "260122pyq1che17",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1chesol17.png"
  },
  {
    "id": "260122pyq1che18",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1chesol18.png"
  },
  {
    "id": "260122pyq1che19",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1chesol19.png"
  },
  {
    "id": "260122pyq1che80",
    "id_type": '260122pyq1che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq1cheques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq1chesol20.png"
  },


    {
    "id": "260122pyq2math1",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2mathsol1.png"
  },
  {
    "id": "260122pyq2math2",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2mathsol2.png"
  },
  {
    "id": "260122pyq2math3",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2mathsol3.png"
  },
  {
    "id": "260122pyq2math4",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2mathsol4.png"
  },
  {
    "id": "260122pyq2math5",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2mathsol5.png"
  },

  {
    "id": "260122pyq2math6",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2mathsol6.png"
  },
  {
    "id": "260122pyq2math7",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2mathsol7.png"
  },
  {
    "id": "260122pyq2math8",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2mathsol8.png"
  },
  {
    "id": "260122pyq2math9",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2mathsol9.png"
  },
  {
    "id": "260122pyq2math10",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2mathsol10.png"
  },
  {
    "id": "260122pyq2math11",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2mathsol11.png"
  },
  {
    "id": "260122pyq2math12",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2mathsol12.png"
  },
  {
    "id": "260122pyq2math13",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2mathsol13.png"
  },
  {
    "id": "260122pyq2math14",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2mathsol14.png"
  },
  {
    "id": "260122pyq2math15",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2mathsol15.png"
  },
  {
    "id": "260122pyq2math16",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2mathsol16.png"
  },
  {
    "id": "260122pyq2math17",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2mathsol17.png"
  },
  {
    "id": "260122pyq2math18",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2mathsol18.png"
  },
  {
    "id": "260122pyq2math19",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2mathsol19.png"
  },
  {
    "id": "260122pyq2math20",
    "id_type": '260122pyq2math',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "math",
    "question_img": "260122pyq2mathques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2mathsol20.png"
  },


  {
    "id": "260122pyq2phy1",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2physol1.png"
  },
  {
    "id": "260122pyq2phy2",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2physol2.png"
  },
  {
    "id": "260122pyq2phy3",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2physol3.png"
  },
  {
    "id": "260122pyq2phy1",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2physol1.png"
  },
  {
    "id": "260122pyq2phy5",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2physol5.png"
  },

  {
    "id": "260122pyq2phy6",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2physol6.png"
  },
  {
    "id": "260122pyq2phy7",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques7.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2physol7.png"
  },
  {
    "id": "260122pyq2phy8",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2physol8.png"
  },
  {
    "id": "260122pyq2phy9",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2physol9.png"
  },
  {
    "id": "260122pyq2phy10",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2physol10.png"
  },
  {
    "id": "260122pyq2phy11",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2physol11.png"
  },
  {
    "id": "260122pyq2phy12",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2physol12.png"
  },
  {
    "id": "260122pyq2phy13",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2physol13.png"
  },
  {
    "id": "260122pyq2phy14",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2physol14.png"
  },
  {
    "id": "260122pyq2phy15",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2physol15.png"
  },
  {
    "id": "260122pyq2phy16",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2physol16.png"
  },
  {
    "id": "260122pyq2phy17",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2physol17.png"
  },
  {
    "id": "260122pyq2phy18",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2physol18.png"
  },
  {
    "id": "260122pyq2phy19",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2physol19.png"
  },
  {
    "id": "260122pyq2phy20",
    "id_type": '260122pyq2phy',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "physics",
    "question_img": "260122pyq2phyques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2physol20.png"
  },

  {
    "id": "260122pyq2che1",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2chesol1.png"
  },
  {
    "id": "260122pyq2che2",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques2.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2chesol2.png"
  },
  {
    "id": "260122pyq2che3",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques3.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2chesol3.png"
  },
  {
    "id": "260122pyq2che4",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques4.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2chesol4.png"
  },
  {
    "id": "260122pyq2che5",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques5.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2chesol5.png"
  },

  {
    "id": "260122pyq2che6",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques6.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2chesol6.png"
  },
  {
    "id": "260122pyq2che1",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques1.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2chesol1.png"
  },
  {
    "id": "260122pyq2che8",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques8.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2chesol8.png"
  },
  {
    "id": "260122pyq2che9",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques9.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2chesol9.png"
  },
  {
    "id": "260122pyq2che10",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques10.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2chesol10.png"
  },
  {
    "id": "260122pyq2che11",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques11.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2chesol11.png"
  },
  {
    "id": "260122pyq2che12",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques12.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2chesol12.png"
  },
  {
    "id": "260122pyq2che13",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques13.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2chesol13.png"
  },
  {
    "id": "260122pyq2che14",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques14.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2chesol14.png"
  },
  {
    "id": "260122pyq2che15",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques15.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2chesol15.png"
  },
  {
    "id": "260122pyq2che16",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques16.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2chesol16.png"
  },
  {
    "id": "260122pyq2che17",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques17.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2chesol17.png"
  },
  {
    "id": "260122pyq2che18",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques18.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2chesol18.png"
  },
  {
    "id": "260122pyq2che19",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques19.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2chesol19.png"
  },
  {
    "id": "260122pyq2che80",
    "id_type": '260122pyq2che',
    "type": "mocktestpyq",
    "year": "2026",
    "subject": "chemistry",
    "question_img": "260122pyq2cheques20.png",
    "option1": "( 1 )",
    "option2": "( 2 )",
    "option3": "( 3 )",
    "option4": "( 4 )",
    "answer": "option",
    "solution_img": "260122pyq2chesol20.png"
  },



  

]

export default AllQuestions;